import React from 'react';
import { Link } from 'react-router-dom';
import '../styling/ProductsSubpages.css';
import solar1 from '../styling/images/solar/nitroxhybrid/category1a.png';
import solar2 from '../styling/images/solar/nitroxhybrid/category1b.png';
import solar3 from '../styling/images/solar/nitroxhybrid/category1c.png';
import solar4 from '../styling/images/solar/nitroxhybrid/category1d.png';

import solar5 from '../styling/images/solar/veyronII/category2a.jpg';
import solar6 from '../styling/images/solar/veyronII/category2b.jpg';
import solar7 from '../styling/images/solar/veyronII/category2c.jpg';
import solar8 from '../styling/images/solar/veyronII/category2d.jpg';
import solar9 from '../styling/images/solar/veyronII/category2e.jpg';
import solar10 from '../styling/images/solar/veyronII/category2f.jpg';

import solar11 from '../styling/images/solar/yukonII/category3a.jpg';
import solar12 from '../styling/images/solar/yukonII/category3b.jpg';

const Solar = () => {
  const categories = [
    { 
      id: 1,
      name: 'NITROX HYBRID SOLAR INVERTER',
      images: [
        { id: 1, src: solar1, caption1: 'Single Phase', caption2: '3KW - 24VDC' },
        { id: 2, src: solar2, caption1: 'Single Phase', caption2: '6KW - 48VDC' },
        { id: 3, src: solar3, caption1: 'Single Phase', caption2: '8KW - 48VDC' },
        { id: 4, src: solar4, caption1: 'Three Phase', caption2: '12KW - 48VDC' }
      ]
    },{
      id: 2,
      name: 'VEYRON II SOLAR INVERTER',
      images: [
        { id: 5, src: solar5, caption1: 'Single Phase', caption2: '1.2KW - 12VDC'  },
        { id: 6, src: solar6, caption1: 'Single Phase', caption2: '2.5KW - 24VDC'  },
        { id: 7, src: solar7, caption1: 'Single Phase', caption2: '3.2KW - 24VDC'  },
        { id: 8, src: solar8, caption1: 'Single Phase', caption2: '3.2KW - 48VDC'  },
        { id: 9, src: solar9, caption1: 'Single Phase', caption2: '4KW - 24VDC'  },
        { id: 10, src: solar10, caption1: 'Single Phase', caption2: '6KW - 48VDC'  }
      ]
    },{
      id: 3, 
      name: 'YUKON II SOLAR INVERTER',
      images: [ 
        { id: 11, src: solar11, caption1: 'Single Phase', caption2: '3.5KW - 24VDC'},
        { id: 12, src: solar12, caption1: 'Single Phase', caption2: '5.6KW - 48VDC'}
      ]
    }
  ];

  const scrollToHeading = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container'>
      <nav className="side-nav">
        <ul>
          {categories.map(category => (
            <li key={category.id}>
              <button onClick={() => scrollToHeading(`heading-${category.id}`)}>{category.name}</button>
              <ul>
                {category.images.map(image => (
                  <li key={image.id}>
                    <Link to={`/product_items/Solar_cat/SolarSubpages/${image.id}`}>
                      {image.caption1}  {image.caption2}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))} 
        </ul>
      </nav>
      <div className="content">
        <h1>SOLAR</h1>
        {categories.map(category => (
          <div key={category.id} id={`heading-${category.id}`}>
            <h2>{category.name}</h2>
            <div className='row'>
              {category.images.map(image => (
                <div key={image.id} className='category-products'>
                  <Link to={`/product_items/Solar_cat/SolarSubpages/${image.id}`} state={{ productCategory: category.name, productCap1: image.caption1, productCap2: image.caption2}}>
                    <img src={image.src} alt={`Image ${image.id}`} className='category-images'/>
                  </Link>
                  <p>{image.caption1}<br/>{image.caption2}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}



export default Solar;
